<form [formGroup]="workflowForm">
  <div class="form-wrapper input-wrapper">
    <!-- Sensitivity Labels Selection -->
    <div class="tree-view">
      <label>Sensitivity Labels</label>
      <kendo-treeview
        [nodes]="sensitivityLabelData"
        textField="label"
        idField="id"
        parentIdField="parentId"
        checkBy="id"
        [filterable]="false"
        [loadOnDemand]="false"
        [(checkedKeys)]="checkedKeys"
        [expandedKeys]="expandedKeys"
        [hasCheckbox]="hasCheckbox"
        (checkedChange)="onSelectionChange($event)"
        kendoTreeViewFlatDataBinding
        kendoTreeViewExpandable
        [kendoTreeViewDisable]="'label'"
        [kendoTreeViewCheckable]="checkableSettings"
        [isDisabled]="isSensitivityLabelDisabled">
        <ng-template kendoTreeViewNodeTemplate let-dataItem>
          <div class="tree-node">
            <mat-icon
              class="material-symbols-outlined red-shield"
              [ngClass]="{'red-shield': dataItem.icon === 'safety_check_off'}"
              [fontIcon]="dataItem.icon"/>
            <span>{{ dataItem.label }}</span>
          </div>
        </ng-template>
      </kendo-treeview>
      @if (workflowForm.get('sensitivityLabels')!.hasError('sensitivityLabelInvalid')
      && (workflowForm.get('sensitivityLabels')!.touched || workflowForm.get('sensitivityLabels')!.dirty)) {
        <mat-error class="mat-mdc-form-field-error error">At least one Sensitivity Label is required.</mat-error>
      }
    </div>

    <mat-form-field class="form-field">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" (blur)="onFieldBlur('name')">

      @if (workflowForm.get('name')!.hasError('required') && (workflowForm.get('name')!.touched || workflowForm.get('name')!.dirty)) {
        <mat-error>Workflow name is required.</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="form-field">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="3"
                (blur)="onFieldBlur('description')"></textarea>

      @if (workflowForm.get('description')!.hasError('required') && (workflowForm.get('description')!.touched || workflowForm.get('description')!.dirty)) {
        <mat-error>Workflow description is required.</mat-error>
      }
    </mat-form-field>

    <keywords-controller [allKeywords]="allKeywords()" [parentForm]="workflowForm"
                         (keywordsChanged)="onKeywordsChanged()"/>
  </div>
</form>
